<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="500px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-descriptions class="margin-top" title="" :column="1" size="mini" border :label-style="{width: '100px'}" :content-style="{width: 'calc(50% - 100px)'}">
        <el-descriptions-item label="收费项目">
          <el-select size="mini" style="width: 100%" v-model="where2.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan">
            <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where2.charging_standard" filterable clearable placeholder="收费标准" class="kuan">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id">
              <span style="float: left">[{{ item.id }}] {{ item.name }}</span>
              <span style="float: right;">
                <el-tag size="mini" type="success" v-if="item.id===master_charge_id">默认组</el-tag>
                <el-tag size="mini" type="success" v-else-if="item.id===one_charge_id">第一组</el-tag>
                <el-tag size="mini" type="success" v-else-if="item.id===two_charge_id">第二组</el-tag>
                <el-tag size="mini" v-else>额外费项</el-tag>
              </span>
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="金额">
          <el-input size="mini" v-model="where2.value" placeholder="金额" class="kuan" ></el-input>
        </el-descriptions-item>
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="submit">确 认</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SelectChargeValue",
  inject: ['mainObj','componentId','setComponentId'],
  data() {
    return {
      dialogVisible: false,
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      chargeItem_name_ids:null,
      callback:null,
      master_charge_id:null,
      one_charge_id:null,
      two_charge_id:null,
      where2:{
        charging_standard:'',
        chargeItem_name_id:'',
        value:''
      },
    };
  },
  mounted() {

  },
  methods: {
    show({master_charge_id,one_charge_id,two_charge_id},callback){
      this.master_charge_id=master_charge_id;
      this.one_charge_id=one_charge_id;
      this.two_charge_id=two_charge_id;
      this.getHouseChargeitemNameList();
      this.mainObj.project_id&&this.getHouseChargeList();
      this.dialogVisible = true;
      this.callback=callback;
    },
    handleClose() {
      this.dialogVisible = false;
      this.callback=null;
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where2.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where2.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    submit(){
      if(!this.where2.chargeItem_name_id){
        this.$message.error('请选择收费项目');
        return;
      }
      if(!this.where2.charging_standard){
        this.$message.error('请选择收费标准');
        return;
      }
      if(!this.where2.value){
        this.$message.error('请输入金额');
        return;
      }
      this.callback&&this.callback(this.where2);
      this.dialogVisible = false;
    }
  },

  watch: {
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/SelectChargeValue.vue